<template>
  <div class="slider pt-5">
    <div class="slides">
      <img src="../assets/images/trustgainers/4pfoten.jpg" />
      <img src="../assets/images/trustgainers/beltz.jpg" />
      <img src="../assets/images/trustgainers/chris.jpg" />
      <img src="../assets/images/trustgainers/cot.jpeg" />
      <img src="../assets/images/trustgainers/dingsundbums.jpeg" />
      <img src="../assets/images/trustgainers/doctolib.jpg" />
      <img src="../assets/images/trustgainers/gold.jpg" />
      <img src="../assets/images/trustgainers/hundw.jpeg" />
      <img src="../assets/images/trustgainers/jane.jpeg" />
      <img src="../assets/images/trustgainers/jupitermond.png" />
      <img src="../assets/images/trustgainers/kati.jpg" />
      <img src="../assets/images/trustgainers/kiran.jpg" />
      <img src="../assets/images/trustgainers/kosmos.svg" />
      <img src="../assets/images/trustgainers/kristin.jpg" />
      <img src="../assets/images/trustgainers/laura.jpeg" />
      <img src="../assets/images/trustgainers/mama.jpg" />
      <img src="../assets/images/trustgainers/piper.jpg" />

      <!-- Repeat images -->
      <img src="../assets/images/trustgainers/4pfoten.jpg" />
      <img src="../assets/images/trustgainers/beltz.jpg" />
      <img src="../assets/images/trustgainers/chris.jpg" />
      <img src="../assets/images/trustgainers/cot.jpeg" />
      <img src="../assets/images/trustgainers/dingsundbums.jpeg" />
      <img src="../assets/images/trustgainers/doctolib.jpg" />
      <img src="../assets/images/trustgainers/gold.jpg" />
      <img src="../assets/images/trustgainers/hundw.jpeg" />
      <img src="../assets/images/trustgainers/jane.jpeg" />
      <img src="../assets/images/trustgainers/jupitermond.png" />
      <img src="../assets/images/trustgainers/kati.jpg" />
      <img src="../assets/images/trustgainers/kiran.jpg" />
      <img src="../assets/images/trustgainers/kosmos.svg" />
      <img src="../assets/images/trustgainers/kristin.jpg" />
      <img src="../assets/images/trustgainers/laura.jpeg" />
      <img src="../assets/images/trustgainers/mama.jpg" />
      <img src="../assets/images/trustgainers/piper.jpg" />
    </div>
  </div>
</template>

<script></script>

<style scoped>
.slider {
  overflow: hidden;
  background-color: black;
  /* -webkit-mask: linear-gradient(90deg, #0000, #000 5% 95%, #0000); */
}

.slides {
  display: flex;
  width: max-content;
  animation: slider-slide-left 40s linear infinite;
}

/* .slides:hover {
  animation-play-state: paused;
} */

.slides img {
  margin-right: 50px;
}

@keyframes slider-slide-left {
  100% {
    transform: translateX(-50%);
  }
}

img {
  width: 200px;
  border-radius: 0.5rem;
}
</style>
